import React from 'react';
import { branch, renderComponent } from 'react-recompose';
import Loader from '../Loader';

export default branch(
  ({ data }) => data && data.loading,
  renderComponent(({ loader }) => <Loader {...loader} active />),
);
